import { Button } from "react-bootstrap";
import { Flag, FontFa } from "../../../../../components";
import {
  RequestLanguage,
  RequestType,
  requestLanguageDetail,
  requestTypeDetail,
} from "../../../../../constants";

export const useECColumns = () => {
  const columns = [
    {
      title: "Mã yêu cầu",
      dataIndex: "id",
      key: "id",
      width: 100,
      align: "center" as const,
    },
    {
      title: "Ngày tạo",
      dataIndex: "createdDateTime",
      key: "createdDateTime",
    },
    {
      title: "Người tạo",
      dataIndex: "createdByName",
      key: "createdByName",
    },
    {
      title: "Yêu cầu",
      dataIndex: "requestType",
      key: "requestType",
      render: (reqType: RequestType) => (
        <Flag flag={requestTypeDetail[reqType].flag}>
          {requestTypeDetail[reqType].label}
        </Flag>
      ),
    },
    {
      title: "Ngôn ngữ",
      dataIndex: "requestLanguage",
      key: "requestLanguage",
      render: (reqLanguage: RequestLanguage) => (
        <span>{requestLanguageDetail[reqLanguage].label}</span>
      ),
    },
    {
      title: "Trạng thái",
      dataIndex: "requestStatus",
      key: "requestStatus",
      render: (text: string) => <Flag flag="warning">{text}</Flag>,
    },
    {
      title: "Xuất tài liệu",
      dataIndex: "action",
      key: "action",
      align: "center" as const,
      render: (text: string, record: any) => (
        <Button
          title={"Xuất file"}
          variant="outline-danger"
          onClick={(e: any) => {
            e.stopPropagation();
          }}
        >
          <FontFa name="faPrint" size={"xs"} />
        </Button>
      ),
    },
  ];

  return { columns };
};
